import { useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { authApi, setCsrfToken } from "@/lib/api"

/**
 * Central hook for the current user + CSRF token.
 * The CSRF token from `/auth/me` is stashed in the API client automatically.
 */
export function useAuth() {
  const query = useQuery({
    queryKey: ["me"],
    queryFn: () => authApi.me(),
    staleTime: 60_000,
  })

  useEffect(() => {
    if (query.data?.csrf) {
      setCsrfToken(query.data.csrf)
    }
  }, [query.data?.csrf])

  return {
    user: query.data?.user ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  }
}
